export interface TabSwitchState {
  activeTab: string;
}

export const initializeTabswitchState = function() {
  return {
    activeTab: "",
  };
};
